export const LOGIN = "login";
export const REQUEST_RESET_PASSWORD = "requestResetPassword";
export const RESET_PASSWORD = "resetPassword";
export const REGISTER = "register";
export const ACTIVATE_USER = "activateUser";
export const LIST_USERS = "listUsers";
export const LIST_ADMIN_USERS = "listAdminUsers";
export const LIST_ROLES = "listRoles";
export const ADD_ROLE = "addRole";
export const EDIT_ROLE = "editRole";
export const LIST_MODULES = "listModules";
export const GET_ROLE = "getRole";
export const GET_ADMIN_USER = "getAdminUser";
export const GET_USER = "getAdminUser";
export const GET_SELECT_ROLES = "getSelectRoles";
export const ADD_USER = "addUser";
export const EDIT_USER = "editUser";
export const GET_DASHBOARD = "getDashboard";
export const CHANGE_PASSWORD = "changePassword";
export const DELETE_ADMIN = "deleteAdmin";
export const GET_LOGS = "getLogs";
export const DELETE_ROLE = "deleteRole";
export const GET_PROFILE = "getProfile";
export const UPDATE_PROFILE = "updateProfile";
export const LIST_CONFIGURATIONS = "listConfigurations";
export const UPDATE_CONFIGURATIONS = "updateConfigurations";
export const CREATE_FUEL_CAPACITY = "createFuelCapacity";
export const LIST_FUEL_CAPACITY = "listFuelCapacity";
export const UPDATE_FUEL_CAPACITY = "updateFuelCapacity";
export const GET_FUEL_CAPACITY = "getFuelCapacity";
export const GET_VEHICLE_LIST = "getVehicleList";








// WEBPACK FOOTER //
// ./src/store/actions.type.js